import { Models } from "fluent-forever-shared-types";
export * from './actions';
export * from './reducer'

export interface ICouponcodeState {
    codeInfo?: Models.ICouponCodeInfo;
}


// WEBPACK FOOTER //
// ./src/store/modules/couponcodes/index.ts